import { useLayoutEffect, useState } from 'react';
import dayjs from '@/js/libs/dayjs';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
const computeTimeLeft = (expiresAtMs, nowMs) => {
    const left = dayjs.duration(Math.max(0, dayjs(expiresAtMs).diff(nowMs)));
    return {
        min: left.minutes(),
        sec: left.seconds(),
    };
};
export const useCountdown = (expiresAtMs, onExpire) => {
    const [timeLeft, setTimeLeft] = useState({ min: 0, sec: 0 });
    const handleExpire = useCallbackRef(() => onExpire?.());
    useLayoutEffect(() => {
        if (expiresAtMs == null) {
            return undefined;
        }
        let intervalId;
        const tick = () => {
            const now = Date.now();
            setTimeLeft(computeTimeLeft(expiresAtMs, now));
            if (now >= expiresAtMs) {
                if (intervalId !== undefined) {
                    window.clearInterval(intervalId);
                    intervalId = undefined;
                }
                handleExpire();
            }
        };
        tick();
        if (Date.now() < expiresAtMs) {
            intervalId = window.setInterval(tick, 1000);
        }
        return () => {
            if (intervalId !== undefined) {
                window.clearInterval(intervalId);
            }
        };
    }, [expiresAtMs, handleExpire]);
    return timeLeft;
};
